/**
 * Display trigger configuration keys in chips
 */
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
import {
  hexToRGB,
  MOON_500,
  MOON_600,
} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, IconCopy} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

const StyledConfigPill = styled.div`
  display: inline-flex;
  height: 24px;
  border-radius: 4px;
  padding: 4px 6px 4px 8px;
  align-items: center;
  background-color: ${hexToRGB(MOON_500, 0.14)};
  color: ${MOON_600};
`;
StyledConfigPill.displayName = 'S.StyledConfigPill';

const StyledConfigKey = styled.div`
  font-size: 13px;
  line-height: 16px;
  margin-right: 8px;
  font-family: 'Source Code Pro';
  font-weight: 400;
  letter-spacing: -0.05em;
`;
StyledConfigKey.displayName = 'S.StyledConfigKey';

const IconConfigKey = styled(IconCopy)`
  width: 13px;
  height: 13px;
  margin-left: 2px;
  cursor: pointer;
`;
IconConfigKey.displayName = 'S.IconConfigKey';

const IconPlusButton = styled(Icon)`
  width: 13px;
  height: 13px;
  margin-left: 0px;
  margin-right: 2px;
  cursor: pointer;
`;
IconPlusButton.displayName = 'S.IconPlusButton';

export const ConfigKey = ({
  configKey,
  onPlusClick,
}: {
  configKey: string;
  onPlusClick?: () => void;
}) => {
  const copyConfigKey = React.useCallback((val: string) => {
    copyToClipboard(val);
    toast(`Copied ${val} to clipboard`);
  }, []);
  return (
    <StyledConfigPill>
      <StyledConfigKey>{configKey}</StyledConfigKey>
      {onPlusClick && <IconPlusButton name="add-new" onClick={onPlusClick} />}
      <IconConfigKey onClick={() => copyConfigKey(`"${configKey}"`)} />
    </StyledConfigPill>
  );
};
